import { IStoreSecurityState } from './security.interface';

export default {
  csrfTokens: []
} as IStoreSecurityState;
